import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react/dist/iconify.js';
import moment from 'moment';
import { toast } from 'react-toastify';
import './style.css';
import Popup from '@/components/popup';
import { HOSPITAL_STATUS_COLOR } from '@/data/hospitalStatus';
import { GetBrokerRequestPreviousOffer } from '@/api/endpoints';

const modalName = "PrevOffersModal";

interface PrevOffer {
  id: number;
  providerName: string;
  price: number;
  requestDate: string;
  status: string;
  pdfPath?: string;
  previousOffers?: PrevOffer[];
}

interface PrevOffersProps {
    PrevRef?:any;
    requestId?:string | number;
}

const PrevOffers: React.FC<PrevOffersProps> = ({ PrevRef   , requestId}) => {
  const { t } = useTranslation();
  const modalRef = PrevRef||useRef<HTMLButtonElement>(null);
  const [offers, setOffers] = useState<PrevOffer[]>([]);
  const [loading, setLoading] = useState(false);
  const handleOpenModal = () => {
    if (requestId) {
      setLoading(true);
      GetBrokerRequestPreviousOffer(requestId)
        .then((res: any) => {
          setOffers(res.data || []);
          setLoading(false);
        })
        .catch((err: any) => {
          toast.error(err.message || t("Failed to load previous offers"));
          setLoading(false);
        });
    } 
  };

  const handleClose = () => {
    modalRef?.current?.click();
  };


useEffect(() => {
    handleOpenModal();
}, [requestId]);

  const getStatusClass = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'quotation ready':
      case 'quotationready':
        return 'status-quotation-ready';
      case 'expired':
        return 'status-expired';
      case 'rejected':
        return 'status-rejected';
      case 'accepted':
        return 'status-accepted';
      default:
        return 'status-quotation-ready';
    }
  };

  const handleViewPricesFile = (pdfPath: string) => {
    if (pdfPath) {
      window.open(pdfPath, '_blank');
    }
  };

  return (
    <div className="prev-offers-container">
      {/* Trigger Button */}
      <button ref={modalRef} data-toggle="modal" data-target={`#${modalName}`} hidden></button>
      
      

      {/* Popup Modal */}
      <Popup name={modalName} onClose={handleClose} large>
        <div className="prev-offers-popup">
          <div className="prev-offers-header">
            <h2 className="prev-offers-title">{t("Previous Offers")}</h2>
          </div>

          <div className="prev-offers-body">
            {offers.length === 0 ? (
              <div className="prev-offers-empty">
                <Icon icon="carbon:document" width={48} />
                <p>{t("No previous offers available")}</p>
              </div>
            ) : (
              <div className="prev-offers-table-wrapper">
                <table className="prev-offers-table">
                  <thead>
                    <tr>
                      <th>{t("Hospital")}</th>
                      <th>{t("Price")}</th>
                      <th>{t("Request Date")}</th>
                      <th>{t("Status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {offers?.previousOffers?.map((offer) => (
                      <tr key={offer.id}>
                        <td className="prev-offers-hospital-name">
                          {offer.providerName}
                        </td>
                        <td className="prev-offers-price">
                          ${offer.price ? Number(offer.price) : '0'}
                        </td>
                       
                        <td>{moment(offer.requestDate).format("MM/DD/YYYY")}</td>
                        <td>
                          <span className={`prev-offers-status ${HOSPITAL_STATUS_COLOR[offer?.orderStatusId]}`}>
                            {t(offer?.orderStatusName) || t("Quotation Ready")}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="prev-offers-footer">
            <button className="prev-offers-close-btn" onClick={handleClose}>
              {t("Close")}
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default PrevOffers;

